import { Flex, Popconfirm, Typography, type PopconfirmProps } from "antd"
import type { ReactNode } from "react"
import {
  hasLimitedVideoTextFidelity,
  VIDEO_TEXT_FIDELITY_WARNING,
} from "~/common/constants"
import { Alert } from "~/components/Alert"

const { Text } = Typography

export type VideoGenerateConfirmProps = Omit<
  PopconfirmProps,
  "description" | "title"
> & {
  description?: ReactNode
  title?: ReactNode
  model: API.Task.CreateVideoChannel
  pointCost: number
}

export const VideoGenerateConfirm = ({
  children,
  description = "请核对生视频脚本、参考素材和模型参数，确认无误后提交生视频。",
  title = "生视频确认",
  okText = "确认生视频",
  cancelText = "取消",
  model,
  pointCost,
  ...props
}: VideoGenerateConfirmProps) => (
  <Popconfirm
    icon={null}
    placement="topRight"
    {...props}
    title={title}
    okText={okText}
    styles={{
      root: {
        maxWidth: 520,
      },
    }}
    cancelText={cancelText}
    description={
      <Flex
        vertical
        gap={4}
      >
        {hasLimitedVideoTextFidelity(model) ? (
          <Alert
            showIcon
            title={VIDEO_TEXT_FIDELITY_WARNING}
            level="weak"
          />
        ) : null}
        <Text>
          {description}本次预计消耗&nbsp;
          <Text style={{ color: "var(--ant-color-primary)" }}>{pointCost}</Text>
          &nbsp;积点
        </Text>
      </Flex>
    }
  >
    {children}
  </Popconfirm>
)
